import React, { Component } from 'react';
import links from 'utils/links';
import { Link } from 'react-router-dom';
// import queryString from 'query-string';
import Welcome from '../../components/welcome';
/** redux **/
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';
import Loader from '../../components/Loader';
import PropTypes from 'prop-types';
// Material Components
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import ReactDOM from 'react-dom';
import Paper from '@material-ui/core/Paper';
// Custom Components
// import HorizontalSlider from '../../components/HorizontalSlider';
// import ContributorContributions from '../../components/ContributorContributions';
import ContributeCard from '../../components/contributorCard/contributeCard';
import Card from '../../components/card/cardslide';
import EventCardSlider from '../../components/card/EventTypeSlider';
import { storeCityName, getCityName } from 'utils/';

const styles = theme => ({
  media: {
    height: 400,
    background:
      'linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.5)),url("/img/Thai_Curry_HP_2.jpg")',
    backgroundSize: 'cover',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imgContainer: {
    textAlign: 'center',
    color: 'white',
  },
  centered: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  imgBody: {
    color: '#ffff',
    padding: '20px',
  },
  top: {
    marginTop: '10px',
    fontSize: '1rem',
  },
  explore: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '30px',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  exploreBtn: {
    height: '30px',
    backgroundColor: 'white',
    top: '12px',
  },
  exploreTxt: {
    color: 'black',
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
  },
  contributorImg: {
    height: 300,
  },
  contributorContent: {
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: '-97px',
    width: '80%',
    marginLeft: '10%',
    backgroundColor: '#ffff',
  },
  contBody: {
    color: '#ffff',
    backgroundColor: theme.palette.ternary.main,
    padding: '20px',
  },
  contributorBtn: {
    marginTop: '10px',
    marginBottom: '10px',
    backgroundColor: '#e8e2e0',
    color: '#ca1414',
  },
  eateryCard: {
    textAlign: 'left',
    // padding: '10px',
    [theme.breakpoints.down('xs')]: {
      padding: '10px',
    },
  },
  aharaBody: {
    color: '#ffff',
    padding: '20px',
    backgroundColor: theme.palette.primary.main,
  },
  aharaBtn: {
    marginTop: '10px',
    marginBottom: '10px',
    backgroundColor: theme.palette.secondary.main,
    color: '#ffff',
  },
  aharaContent: {
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: '-97px',
    width: '70%',
    marginLeft: '5%',
    backgroundColor: '#ffff',
  },
  eventCard: {
    padding: '10px',
    marginTop: '10px',
  },
  contCard: {
    padding: '20px',
    backgroundColor: theme.palette.ternary.light,
    marginBottom: '10px',
    paddingBottom: '0px',
  },
  whiteContainer: {
    backgroundColor: '#fafafa',
  },
  loadingContainer: {
    position: 'fixed',
    width: '100%',
    top: '50px',
    paddingTop: '50%',
    height: '100%',
    backgroundColor: '#fff',
    zIndex: '1000',
  },
  liveExperiencelink: {
    textDecoration: 'underline',
    color: '#c44a33',
  },
  centering: {
    [theme.breakpoints.only('lg')]: {
      maxWidth: '75%',
      marginLeft: 'auto',
      marginRight: 'auto',
      lineHeight: '1.5',
    },
  },
  seeAllEateries: {
    marginTop: '-3%',
    textAlign: 'center',
    fontSize: '1rem',
    textDecoration: 'underline',
  },
});

class Home extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  state = {
    labelWidth: 0,

    localcuisines: [],
  };
  componentWillMount() {
    storeCityName(this.props.match.params.cityname);
  }
  componentDidMount() {
    this.props.dispatch(actions.getData(getCityName()));
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.loading && !this.props.loading) {
      this.setState({
        labelWidth: ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth,
      });
    }
    if (prevProps.match.params.cityname !== this.props.match.params.cityname) {
      this.props.dispatch(actions.getData(getCityName()));
    }
  }
  handleChange = event => {
    storeCityName(event.target.value);
    this.props.history.push(links.home());
    this.props.dispatch(actions.getData(event.target.value));
  };
  render() {
    const {
      classes,
      history,
      loading,
      cities,
      topPicks,
      localDelights,
      topContributors,
      nativeFood,
      experiences,
      localEateries,
      localArticles,
    } = this.props;
    // const cityname = this.props.match.params.cityname;
    const cityname = getCityName();
    const filterTopPicks = topPicks.filter(function(data) {
      return data.imageUrl !== null;
    });
    const filterlocalDelights = localDelights.filter(function(data) {
      return data.imageUrl !== null;
    });
    const filternativeFood = nativeFood.filter(function(data) {
      return data.imageUrl !== null;
    });
    const filterlocalEateries = localEateries.filter(function(data) {
      return data.imageUrl !== null;
    });
    const filterlocalArticles = localArticles.filter(function(data) {
      return data.imageUrl !== null;
    });
    const filterTopContributor = topContributors.filter(function(datas) {
      return datas.profilePic !== null;
    });

    if (loading) {
      return <Loader />;
    } else {
      let currentCityName = '';
      let localCuisinesName = '';
      for (var i = 0; i < cities.length; i++) {
        if (cities[i].cityID === cityname) {
          currentCityName = cities[i].cityName;
          if (currentCityName)
            localCuisinesName = cities[i].localCuisines.map(cuisines => {
              return cuisines.name;
            });
        }
      }

      return (
        <div>
          <Welcome />
          <Grid container>
            <Grid item xs={12} className={classes.ImgContainer}>
              <div className={classes.media}>
                <div className={classes.centered}>
                  <Typography variant="h6" className={classes.imgBody}>
                    TALKING STREET
                  </Typography>
                  <Typography
                    variant="overline"
                    className={[
                      classes.imgBody,
                      classes.top,
                      classes.centering,
                    ].join(' ')}
                  >
                    Talking Street is a community for foodies, by foodies.
                    <br />
                    Discover eateries recommended by locals, read stories by
                    food pundits and experience cuisines and culture first hand,
                    across 35+ Indian destinations.
                  </Typography>
                  <Link to={links.aboutTalkingstreet()}>
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.top}
                    >
                      Read more
                    </Button>
                  </Link>
                </div>
              </div>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} className={classes.explore}>
              <Typography variant="body2" className={classes.exploreTxt}>
                Explore food in
              </Typography>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel
                  ref={ref => {
                    this.InputLabelRef = ref;
                  }}
                  htmlFor="explore-city"
                />
                <Select
                  native
                  value={cityname}
                  onChange={this.handleChange}
                  style={{ height: '30px' }}
                  input={
                    <OutlinedInput
                      name="city"
                      labelWidth={this.state.labelWidth}
                      id="explore-city"
                    />
                  }
                >
                  {cities.map(city => (
                    <option key={city.cityID} value={city.cityID}>
                      {city.cityName}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Typography variant="body2" className={classes.seeAllEateries}>
            <Link to={links.searchLink(cityname)}>
              SEE ALL EATERIES IN CITY
            </Link>
          </Typography>
          <div className={classes.eateryCard}>
            {topPicks.length > 0 ? (
              <Typography
                variant="body2"
                className={classes.top}
                style={{ fontWeight: 'bold' }}
              >
                {'TS RECOMMENDS'}
              </Typography>
            ) : (
              ''
            )}
            <div className={classes.top}>
              <Card history={history} cards={filterTopPicks} />
              {/* <Card history={history} cards={filterTopPicks} /> */}
            </div>
          </div>
          <Grid container>
            <Grid item xs={12}>
              <CardMedia
                className={classes.contributorImg}
                image="/img/HP4.jpg"
                title="about us"
              />
            </Grid>
            <div className={classes.aharaContent}>
              <Paper
                className={classes.aharaBody}
                style={{ textAlign: 'left' }}
              >
                <Typography
                  variant="h6"
                  style={{ color: '#ffff' }}
                  component="h6"
                >
                  {' '}
                  āhāra
                </Typography>
                <Typography
                  variant="caption"
                  component="h6"
                  className={classes.top}
                  style={{
                    color: '#ffff',
                    lineHeight: '20px',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                  }}
                >
                  Hand-crafted experiences designed with culinary experts to
                  provide windows to cuisines and cultures.
                  <br />
                  We are live in following cities:
                  {'  '}
                  <a
                    href={links.ourLiveExperienceCities('bengaluru')}
                    className={classes.liveExperiencelink}
                  >
                    Bangalore
                  </a>
                  {'  '}
                  <a
                    href={links.ourLiveExperienceCities('varanasi')}
                    className={classes.liveExperiencelink}
                  >
                    Varanasi
                  </a>
                  {'  '}
                  <a
                    href={links.ourLiveExperienceCities('mumbai')}
                    className={classes.liveExperiencelink}
                  >
                    Mumbai
                  </a>{' '}
                  <a
                    href={links.ourLiveExperienceCities('delhi')}
                    className={classes.liveExperiencelink}
                  >
                    Delhi
                  </a>
                </Typography>
                <Link to={links.experiences(cityname)}>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.aharaBtn}
                  >
                    Read more
                  </Button>
                </Link>
              </Paper>
            </div>
          </Grid>
          <div className={classes.eventCard}>
            <EventCardSlider history={history} cards={experiences} />
          </div>
          <Grid container>
            <Grid item xs={12}>
              <CardMedia
                className={classes.contributorImg}
                image="/img/HP_Food_Pundits.jpg"
                title="about us"
              />
            </Grid>
            <div className={classes.contributorContent}>
              <Paper className={classes.contBody}>
                <Typography
                  variant="h6"
                  component="h6"
                  style={{ color: '#ffff' }}
                >
                  {' '}
                  Our Pundits
                </Typography>
                <Typography
                  variant="caption"
                  component="h6"
                  style={{ color: '#ffff', lineHeight: '20px' }}
                >
                  TS's Food Pundits, with their deep knowledge on cuisines and
                  insights on where to eat, are the foodie friends you wish for
                  in every city. Their passion for food translates into stories
                  and recommendations leading you to incredible food
                  experiences.
                </Typography>
                <Link to={links.staticLink('community')}>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.contributorBtn}
                  >
                    Read more
                  </Button>
                </Link>
              </Paper>
            </div>
          </Grid>
          <br />
          <div className={classes.eateryCard}>
            {nativeFood.length > 0 ? (
              <Typography
                variant="body2"
                className={classes.top}
                style={{ fontWeight: 'bold' }}
              >
                BEST OF {currentCityName.toLocaleUpperCase()} [
                {localCuisinesName
                  .map(cuiName => cuiName.toUpperCase())
                  .join(', ')}
                ] CUISINES
              </Typography>
            ) : (
              ''
            )}
            <div className={classes.top}>
              <Card history={history} cards={filternativeFood} />
            </div>
          </div>
          <div className={classes.eateryCard}>
            {localDelights.length > 0 ? (
              <Typography
                variant="body2"
                className={classes.top}
                style={{ fontWeight: 'bold' }}
              >
                {'LOCALS RECOMMEND'}
              </Typography>
            ) : (
              ''
            )}
            <div className={classes.top}>
              <Card history={history} cards={filterlocalDelights} />
            </div>
          </div>
          <div className={classes.contCard}>
            <ContributeCard contributors={filterTopContributor} />
            {/* <ContributorCards contributors={filterTopContributor} /> */}
          </div>{' '}
          <br />
          <div className={classes.whiteContainer}>
            <div className={classes.eateryCard}>
              {localEateries.length > 0 ? (
                <Typography
                  variant="body2"
                  className={classes.top}
                  style={{ fontWeight: 'bold' }}
                >
                  ALL EATERIES IN {currentCityName.toUpperCase()}
                </Typography>
              ) : (
                ''
              )}
              <div className={classes.top}>
                <Card history={history} cards={filterlocalEateries} />
              </div>
            </div>
            <div className={classes.eateryCard}>
              {localArticles.length > 0 ? (
                <Typography
                  variant="body2"
                  className={classes.top}
                  style={{ fontWeight: 'bold' }}
                >
                  ARTICLES RELATED TO {currentCityName.toUpperCase()}
                </Typography>
              ) : (
                ''
              )}
              <div className={classes.top}>
                <Card history={history} cards={filterlocalArticles} />
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(Home));
